import Layout from "@/components/layouts/Layout";
import HeroSection from "@/components/sections/HeroSection";
import ServicesSection from "@/components/sections/ServicesSection";
import CommunitySection from "@/components/sections/CommunitySection"
import EventsSection from "@/components/sections/EventsSection";
import CrowdsourcedSection from "@/components/sections/CrowdsourcedSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import CtaSection from "@/components/sections/ctaSection";

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <CommunitySection />
      <ServicesSection />
      <EventsSection />
      <CrowdsourcedSection />
      <TestimonialsSection />
      <CtaSection />
    </Layout>
  );
};

export default Index;
